import { getLoadingState } from 'client/js/common/selectors/DruidSelectors';
import { getTableModeSwitcherStyles } from 'client/js/main/screens/ScreenRoiHub/styles';
import { ImageService } from 'client/js/main/services/ImageService/ImageService';
import { useSelector } from 'client/js/redux';
import { useEffect, useState } from 'react';
import type { ReportActiveMode } from '../../../../../../../shared/types/roi-hub/TableModeSwitcher.types';
import { DomainAnalyticsService } from '../../../../services/analytics/DomainAnalyticsService';

type TableModeSwitcherProps = {
  context: string;
  activeMode: ReportActiveMode;
  updateActiveMode: (viewMode: ReportActiveMode) => void;
};

const useTableModeSwitcherService = ({ updateActiveMode, context, activeMode }: TableModeSwitcherProps) => {
  const domainAnalytics = DomainAnalyticsService.build();

  const [isDisabled, setDisabled] = useState(false);
  const isDruidLoading = useSelector(getLoadingState);

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignored using `--suppress`
  useEffect(() => {
    setDisabled(true);
  }, [activeMode]);

  useEffect(() => {
    if (!isDruidLoading) {
      setDisabled(false);
    }
  }, [isDruidLoading]);

  const iconPath = ImageService.getImageUrl('/static/images/roi-hub/tree-view-icon.svg');

  const css = getTableModeSwitcherStyles(activeMode, iconPath, isDisabled);

  const onTreeButtonClick = () => {
    updateActiveMode('tree');
  };

  const onFlatButtonClick = () => {
    updateActiveMode('flat');
  };

  return {
    hide: !domainAnalytics.isDrillDownEnabled(context),
    css,
    onTreeButtonClick,
    onFlatButtonClick,
    activeMode,
    disabled: isDisabled,
  };
};

export default useTableModeSwitcherService;
